import { Row } from "antd"
import { Text } from "components/common"
import dayjs from "dayjs"
import { fractionizeTime } from "features/workflows/utils"

const Ageing = ({ data }) => {
  return (
    <>
      <Text type={dayjs.duration(data?.ageing, "seconds").days() > data?.turnAroundTime ? "danger" : null}>
        {fractionizeTime(data?.stageAgeing)}
      </Text>
      {data?.turnAroundTime != null && <Row className="gray-800">{`TAT:${data?.turnAroundTime}`}</Row>}
    </>
  )
}

export default Ageing
